/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Friday_NewsletterInputs */

const en_why_listening_friday_newsletter = /** @type {(inputs: Why_Listening_Friday_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friday newsletter`)
};

const es_why_listening_friday_newsletter = /** @type {(inputs: Why_Listening_Friday_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter del viernes`)
};

/**
* | output |
* | --- |
* | "Friday newsletter" |
*
* @param {Why_Listening_Friday_NewsletterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_friday_newsletter = /** @type {((inputs?: Why_Listening_Friday_NewsletterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Friday_NewsletterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_friday_newsletter(inputs)
	return en_why_listening_friday_newsletter(inputs)
});